module.exports = __webpack_public_path__ + "img/LOGO1.b556b894.png";